<div class="container px-5 pt-5 mt-md-3" *ngIf="dashboardForm">
  <div class="row form-group required" [formGroup]="dashboardForm">
    <div class="col-12 text-center">
      <div class="row pb-3 pb-md-2 justify-content-center">
          <span
            [ngClass]="{'text-danger': requestedEffectiveDate.invalid && (requestedEffectiveDate.dirty || requestedEffectiveDate.touched)}"
            class="control-label">{{'common.formFieldsLabels.effectiveDate' | translate}}
          </span>
      </div>
      <div class="row pb-3 pb-md-2 justify-content-center">
        <div class="col-12 col-md-3 input-group">
          <input
          [dropSpecialCharacters]="false"
          [ngClass]="{'is-invalid': requestedEffectiveDate.invalid && (requestedEffectiveDate.dirty || requestedEffectiveDate.touched)}"
          class="form-control"
          formControlName="requestedEffectiveDate"
          mask="M0/d0/0000"
          name="requestedEffectiveDate"
          placeholder="MM/DD/YYYY"
          type="text"
          AutocompleteOffDirective
        >
          <div *ngIf="requestedEffectiveDate?.errors?.required"
             class="invalid-feedback">{{'common.formErrors.required' | translate}}</div>
          <div *ngIf="requestedEffectiveDate?.errors?.mask"
             class="invalid-feedback">{{'common.formErrors.format' | translate: {format: 'MM/DD/YYYY'} }}</div>
          <div *ngIf="requestedEffectiveDate?.errors?.invalidDate"
             class="invalid-feedback">{{'common.formErrors.invalidValue' | translate}}</div>
          <div *ngIf="requestedEffectiveDate?.errors?.firstDayOfMonth"
             class="invalid-feedback">{{'common.formErrors.firstOfMonth' | translate}}</div>
          <div *ngIf="requestedEffectiveDate?.errors?.dateRange"
             class="invalid-feedback">{{'common.formErrors.range' | translate: {
            'min': requestedEffectiveDate?.errors?.dateRange?.min,
            'max': requestedEffectiveDate?.errors?.dateRange?.max
            } }}
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="row pb-3 pb-md-2 justify-content-center">
    <div class="col-12 col-md-3 d-flex justify-content-center">
      <button (click)="resolveApplicationYear()" class="btn btn-success btn-lg"
              type="button">{{ translationPrefix + '.actions.resolveYear' | translate }}</button>
    </div>
   </div>
</div>
